import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import Spinner from 'static/script/libs/spin';

function FullPageImageZoom() {
    let overlayTemplate = $(
        '<div class="image-zoom image-zoom-loading" >' +
        '<div class="image-zoom-wrapper">' +
        '<span class="image-zoom-hint">Tryck för att stänga</span><img/>' +
        '</div>' +
        '</div>');

    this._show = function (evt, evtData) {
        let src = evtData.current;

        this.$overlay = overlayTemplate.clone();
        let img = this.$overlay.find('img');
        img.attr('src', src);

        this.spinner = new Spinner().spin();
        this.$overlay.append(this.spinner.el);

        this.initialScroll = window.scrollY;

        this.$node.prepend(this.$overlay);
        this.$node.addClass('main-content-minimized');

        img.on('load', this._afterImageLoad.bind(this));

        this._attachHide();
    };

    this._afterImageLoad = function () {
        this.$overlay.removeClass('image-zoom-loading');
        this._adjustLayout();
        this.spinner.stop();
        this._hideHintAfterDelay();
    };


    this._adjustLayout = function () {
        if (window.innerHeight >= this.$overlay.height()) {
            this.$overlay.find('.image-zoom-hint').css('position', 'absolute');
        }
        window.scrollTo(this.$overlay.width() / 2 - window.innerWidth / 2, 0);
    };

    this._hide = function () {
        window.scrollTo(0, this.initialScroll);
        this.$node.removeClass('main-content-minimized');
        this.$overlay.remove();

        this.trigger(document, 'ui:view-item:on-image-zoom-close');
        this.off(window, 'hashchange', this._hide);
        this.trigger(document, 'ui:resume-navigation');
    };

    this._attachHide = function () {
        this.trigger(document, 'ui:pause-navigation');
        window.location.hash = 'zoom';

        setTimeout(function () {
            this.on(window, 'hashchange', this._hide);
            this.$overlay.on('click', function () { window.history.go(-1); });
        }.bind(this), 0);

    };

    this._hideHintAfterDelay = function () {
        setTimeout(function () {
            this.$overlay.find('.image-zoom-hint').css('opacity', 0);
        }.bind(this), 1000);
    };

    this.after('initialize', function () {
        this.on('ui:view-item:image-zoom-fullpage', this._show);
    });
}

module.exports = defineComponent.component(FullPageImageZoom);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/image-zoom-fullpage.js